import { ApiBase } from './ApiBase';
class ThankYouCardApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getSettings = (params) => {
            return this.get(`/shops/${params.shopId}/thank-you-card-settings`);
        };
        this.updateSettings = (params, body) => {
            return this.put(`/shops/${params.shopId}/thank-you-card-settings`, body);
        };
        this.getUploadUrl = (params, body) => {
            return this.post(`/shops/${params.shopId}/thank-you-card-photo`, body);
        };
    }
}
export const ThankYouCardApiClient = new ThankYouCardApiClientModel();
